module.exports = __webpack_public_path__ + "img/program-1-1.025769bf.png";